/**
 * CourtesyType Enum - Based on CourtesyType.java
 * Kind of coverage a courtesy grants: an open period of several days or a single
 * session that covers only the day it is granted.
 */
export enum CourtesyType {
  OPEN = 'OPEN',
  SESSION = 'SESSION',
}

export const COURTESY_TYPE_LABEL: Record<CourtesyType, string> = {
  [CourtesyType.OPEN]: 'Cortesía',
  [CourtesyType.SESSION]: 'Sesión',
};
